import { render, staticRenderFns } from "./TrackingComplaint.vue?vue&type=template&id=64f24aeb&"
import script from "./TrackingComplaint.vue?vue&type=script&lang=js&"
export * from "./TrackingComplaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports